<template>
  <div class="mc-period-wrapper">
    <h4 class="ms-1">{{ $t('report.filters.expenses') }}</h4>
    <b-form-group v-for="(field, key) in fields" :key="key">
      <div class="mc-period-group d-flex justify-content-between">
        <label>{{ field._label }}</label>
        <span :id="`period-tooltip-info`">
          <i class="mc-fa icon-outline_info" />
        </span>
        <b-tooltip :target="`period-tooltip-info`" triggers="hover" placement="bottomRight">
          Periode laporan yang dapat diambil maksimal 7 hari pada rentang periode 3 bulan kebelakang.
        </b-tooltip>
      </div>
      <FormulateInput
        v-bind="field" 
        validation-behavior="live"
        :help="field?.validation?.includes('required')"
      />
    </b-form-group>
  </div>
</template>

<script>
import { tableFilterFields } from './lib/tableFilterFields'

export default {
  data() {
    return {
      fields: tableFilterFields.filter(field => field.isShow),
    }
  },
}
</script>
<style lang="scss" scoped>
.mc-period-wrapper {
  :deep(.mc-period-group) {
    padding: 5px 5px 0 5px;
  }
}
</style>
